<template>
  <main>
    <div class="wrap-content wrap-forms" v-if="user">
      <div class="content">
        <h1>{{ user.displayName }}</h1>
        <img :alt="user.displayName" :src="user.photoURL" height="100px" v-if="user.photoURL" width="100px">
        <input ref="inputImage" type="file" accept="image/*" @change="uploadImage">
        <h2>Information</h2>
        <form @submit.prevent="setProfile" id="form-profile">
          <label for="name">Display Name</label>
          <input id="name" name="name" required="required" type="text" v-model="displayName">
          <label for="email">Email</label>
          <input id="email" name="email" required="required" type="email" v-model="email">
          <button class="right">Save Changes</button>
        </form>
        <template v-if="user.email">
          <h2>Password</h2>
          <form @submit.prevent="setPassword" id="form-password">
            <template v-if="emailFederated">
              <label for="current-password">Current Password</label>
              <input autocomplete="on" autofocus="autofocus" id="current-password" name="current_password"
                     pattern=".{6,}"
                     required="required" title="6 characters minimum" type="password">
              <label for="new_password">New Password</label>
            </template>
            <label for="new_password" v-if=" ! emailFederated">Set Password</label>
            <input id="new_password" name="new_password" pattern=".{6,}" required="required"
                   title="6 characters minimum"
                   type="password" v-model="password">
            <button class="right">Save Changes</button>
          </form>
        </template>
        <h2>Linked Accounts</h2>
        <ul>
          <li v-if="googleFederated">
            <form @submit.prevent="unlinkGoogle" id="form-disconnect-google">
              <p>You are connected to Google.</p>
              <p>You can now sign in to PxFlux using your Google account.</p>
              <p>{{ googleFederated.email }}</p>
              <img :alt="googleFederated.displayName" :src="googleFederated.photoURL" height="48px"
                   v-if="googleFederated.photoURL" width="48px">
              <button class="right" v-if="multipleAuth">Disconnect</button>
            </form>
          </li>
          <li v-if=" ! googleFederated">
            <form @submit.prevent="linkGoogle" id="form-connect-google">
              <button class="right">Connect to Google</button>
            </form>
          </li>
        </ul>
        <h2>Email Preferences</h2>
        <form>
          <label for="receive_emails">Receive Emails</label>
          <input checked="checked" id="receive_emails" name="receive_emails" type="checkbox">
          <button class="right">Save Changes</button>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import firebaseApi from '../api/firebase-api'
import upload from '../api/backblaze-api'

export default {
  data () {
    return {
      displayName: this.user ? this.user.displayName : '',
      email: this.user ? this.user.email : '',
      password: ''
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters('profile', ['googleFederated', 'emailFederated', 'multipleAuth'])
  },
  methods: {
    ...mapActions('profile', ['updateProfile', 'updatePassword', 'unlinkGoogle', 'linkGoogle']),
    setProfile () {
      this.updateProfile(this)
    },
    setPassword () {
      this.updatePassword(this)
      this.password = ''
    },
    async uploadImage (event) {
      const files = event.target.files || event.dataTransfer.files
      if (!files) {
        return
      }
      const file = files[0]
      if (!file) {
        return
      }
      switch (file.type) {
        case 'image/jpeg':
        case 'image/jpg':
        case 'image/png':
        case 'image/gif':
          break
        default:
          return
      }

      const { data: { uploadUrl, authorizationToken } } = await firebaseApi.backblaze.getUploadUrl()
      return upload(authorizationToken, uploadUrl, file)
    }
  }
}
</script>
